import { render, staticRenderFns } from "./statisticsEarthwork.vue?vue&type=template&id=4671fd34&scoped=true"
import script from "./statisticsEarthwork.vue?vue&type=script&lang=js"
export * from "./statisticsEarthwork.vue?vue&type=script&lang=js"
import style0 from "./statisticsEarthwork.vue?vue&type=style&index=0&id=4671fd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4671fd34",
  null
  
)

export default component.exports